/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './site-details.scss';

/* eslint-disable import/no-unresolved, import/default */

import siteDetailsTemplate from './site-details.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siteDetails', [])
    .directive('agSiteDetails', SiteDetails)
    .name;

/*@ngInject*/
function SiteDetails() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SiteDetailsController,
        controllerAs: 'vm',
        templateUrl: siteDetailsTemplate
    };
}

/*@ngInject*/
function SiteDetailsController($scope, $translate, agTypes, types, agUtils, siteService, userService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siteId = null;
    vm.site = null;

    vm.siteColor = siteColor;
    vm.siteStatusText = siteStatusText;

    vm.helpPageAction = agUtils.createHelpActionConfig("agSite");

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;
            vm.siteId = null;
            if (vm.ctx.stateController) {
                vm.siteId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSite();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiteId, prevSiteId) {
                    if (newSiteId && !angular.equals(newSiteId, prevSiteId)) {
                        vm.siteId = newSiteId;
                        loadSite();
                    }
                }
            );
        }
    });

    $scope.$watch(function() { return vm.site ? (vm.site.label || vm.site.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('alarmsUpdated', function() {
        loadSite();
    });

    function loadSite() {
        vm.site = null;
        if (vm.siteId) {
            vm.loading = true;
            siteService.getSite(vm.siteId, true).then(
                (site) => {
                    vm.site = site;
                    vm.loading = false;
                },
                () => {
                    vm.loading = false;
                }
            );
        }
    }

    function siteColor() {
        if (vm.site && vm.site.highestAlarmSeverity === 'CRITICAL') {
            if (vm.site.highestAlarmStatus === types.alarmStatus.activeUnack) {
                return agTypes.colors.errorColor;
            }
            return agTypes.colors.normalGreyColor;
        } else {
            return agTypes.colors.normalColor;
        }
    }

    function siteStatusText() {
        if (vm.site && vm.site.highestAlarmSeverity === 'CRITICAL') {
            if (vm.site.highestAlarmStatus === types.alarmStatus.activeUnack) {
                return 'ag.site.status-alarms';
            }
            return 'ag.site.status-alarms-stale';
        } else {
            return 'ag.site.status-normal';
        }
    }
}